import { useI18n } from '../../../i18n'
import styles from '../../../styles/enterprise/EnterpriseOperationalUx.module.scss'

type Props = {
  recommendations: string[]
}

export default function OperationalRecommendationsPanel({ recommendations }: Props) {
  const { t } = useI18n()
  if (!recommendations.length) {
    return (
      <p className={styles.emptyState}>
        {t('enterpriseOperationalUx.context.noRecommendations', 'No operational recommendations at this time')}
      </p>
    )
  }
  return (
    <div>
      <p className={styles.postureMetricLabel}>
        {t('enterpriseOperationalUx.context.operationalRecommendation', 'Operational recommendation')}
      </p>
      <ul className={styles.recommendationList}>
        {recommendations.map((a) => (
          <li key={a}>{a}</li>
        ))}
      </ul>
    </div>
  )
}
